import React from 'react';
import classNames from 'classnames';

const Progress = ({ percent, text }) => { 
    
    const sliderStopClasses = classNames({
        'slider-container__slider-stop': true,
        'right-offset-75': percent === 100,
        'right-offset-50': percent >= 98 && percent !== 100,
    })
    
    return <div className="slider-container">
      <p style={{ fontWeight: 'bold' }}>
        {text}
      </p>
      <div aria-hidden="true" className="slider-container__slider">
        <div className="slider-container__slider-progress" style={{ width: `${percent}%` }}/>
        <div className={ sliderStopClasses } style={{ left: `${percent}%` }}>
          {percent}%
        </div>
      </div>
    </div>
}

export default Progress;